import { features } from "./features";

const INTERNAL_ROLES = new Set(["superuser", "hr", "project_manager", "developer", "designer", "marketing", "staff"]);
const PEOPLE_ROLES = new Set(["superuser", "hr"]);
const APPLICATION_ROLES = new Set(["superuser", "hr"]);
const APPROVAL_ROLES = new Set(["superuser", "hr", "project_manager"]);

export const NOTIFICATION_CATEGORIES = [
  { key: "all", label: "All" },
  { key: "unread", label: "Unread" },
  { key: "message", label: "Messages", types: ["message", "new_message"] },
  { key: "project", label: "Projects", types: ["project", "project_delayed", "project_request", "action_item", "milestone", "launch", "invoice", "file"] },
  { key: "people", label: "People", types: ["team_removal_requested", "employment_review_requested", "member_removal", "personnel_review"] },
  { key: "application", label: "Applications", types: ["job_application", "hiring_approval"] },
  { key: "approval", label: "Approvals", types: ["approval"] },
  { key: "lead", label: "Leads", types: ["lead"] },
  { key: "commission", label: "Commissions", types: ["commission"] },
  { key: "system", label: "System", types: ["system", "workboard"] },
];

export const NOTIFICATION_TYPE_LABELS = {
  action_item: "Project",
  approval: "Approval",
  commission: "Commission",
  employment_review_requested: "People",
  file: "File",
  hiring_approval: "Application",
  invoice: "Invoice",
  job_application: "Application",
  launch: "Launch",
  lead: "Lead",
  meeting: "Meeting",
  member_removal: "People",
  message: "Message",
  milestone: "Project",
  new_message: "Message",
  personnel_review: "People",
  project: "Project",
  project_delayed: "Project Alert",
  project_request: "Project Request",
  system: "System",
  team_removal_requested: "People",
  workboard: "Workboard",
};

function currentRole() {
  if (localStorage.getItem("is_superuser") === "true") return "superuser";
  return localStorage.getItem("portal_role") || "client";
}

function currentContext() {
  const role = currentRole();
  return {
    role,
    isInternal: localStorage.getItem("is_internal") === "true" || INTERNAL_ROLES.has(role),
    isPartner: localStorage.getItem("is_partner") === "true" || role === "partner",
  };
}

function hasCategoryNotifications(category, notifications) {
  if (!category.types) return true;
  return notifications.some((notification) => category.types.includes(notification.notification_type || notification.type));
}

export function getNotificationCategories(notifications = []) {
  const { role, isInternal, isPartner } = currentContext();
  return NOTIFICATION_CATEGORIES.filter((category) => {
    if (["all", "unread", "message", "project", "system"].includes(category.key)) return true;
    if (category.key === "people") return PEOPLE_ROLES.has(role) || hasCategoryNotifications(category, notifications);
    if (category.key === "application") return APPLICATION_ROLES.has(role) || hasCategoryNotifications(category, notifications);
    if (category.key === "approval") return APPROVAL_ROLES.has(role) || hasCategoryNotifications(category, notifications);
    if (["lead", "commission"].includes(category.key)) return isPartner || hasCategoryNotifications(category, notifications);
    return isInternal || hasCategoryNotifications(category, notifications);
  });
}

export function notificationMatchesCategory(notification, categoryKey) {
  if (categoryKey === "all") return true;
  if (categoryKey === "unread") return !notification.read && !notification.is_read;
  if (categoryKey === "meeting" && !features.meetingsEnabled) return false;
  const category = NOTIFICATION_CATEGORIES.find((item) => item.key === categoryKey);
  if (!category?.types) return true;
  return category.types.includes(notification.notification_type || notification.type);
}

export function notificationTypeLabel(notification) {
  const type = notification.notification_type || notification.type || "system";
  return NOTIFICATION_TYPE_LABELS[type] || type.split("_").map((part) => part.charAt(0).toUpperCase() + part.slice(1)).join(" ");
}

export function categoryLabel(categories, categoryKey) {
  return categories.find((category) => category.key === categoryKey)?.label || "Notifications";
}




